import { render, staticRenderFns } from "./MaterialInventoryDetails.vue?vue&type=template&id=4bc88ee0&scoped=true"
import script from "./MaterialInventoryDetails.vue?vue&type=script&lang=js"
export * from "./MaterialInventoryDetails.vue?vue&type=script&lang=js"
import style0 from "./MaterialInventoryDetails.vue?vue&type=style&index=0&id=4bc88ee0&prod&scoped=true&lang=scss"
import style1 from "./MaterialInventoryDetails.vue?vue&type=style&index=1&id=4bc88ee0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc88ee0",
  null
  
)

export default component.exports